export const AQUARIST_LOGO = require('../assets/aquarist.png')
